export default {
  signIn: 'Se connecter',
  signOut: 'Se déconnecter',
  points: 'points',
  hyattSignInButton: 'Connectez-vous à World of Hyatt',
};
